import { useState } from 'react';
import { useBulkDeleteDeals } from '@/hooks/useDeals';
import { Button, Input, Modal } from '@solid/ui';

export function BulkDeleteDialog({
  dealIds,
  open,
  onOpenChange,
  onSuccess,
}: {
  dealIds: string[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
}) {
  const [confirmation, setConfirmation] = useState('');
  const bulkDelete = useBulkDeleteDeals();
  const count = dealIds.length;
  const isConfirmed = confirmation === String(count);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!isConfirmed) return;
    await bulkDelete.mutateAsync(dealIds);
    setConfirmation('');
    onOpenChange(false);
    onSuccess();
  };

  return (
    <Modal
      open={open}
      onOpenChange={(v) => { if (!v) setConfirmation(''); onOpenChange(v); }}
      title="Delete Deals"
      description={`You are about to permanently delete ${count} deal${count !== 1 ? 's' : ''}. This action cannot be undone.`}
      footer={
        <>
          <Button variant="ghost" onClick={() => { setConfirmation(''); onOpenChange(false); }}>
            Cancel
          </Button>
          <Button
            type="submit"
            form="bulk-delete-deals-form"
            variant="destructive"
            disabled={!isConfirmed}
            loading={bulkDelete.isPending}
          >
            Delete {count} Deal{count !== 1 ? 's' : ''}
          </Button>
        </>
      }
    >
      <form id="bulk-delete-deals-form" onSubmit={handleSubmit} className="space-y-4">
        <Input
          label={`Type "${count}" to confirm`}
          placeholder={String(count)}
          value={confirmation}
          onChange={(e) => setConfirmation(e.target.value)}
          autoFocus
        />
      </form>
    </Modal>
  );
}
